module.exports = __webpack_public_path__ + "static/website-spa-march-2020-cd06e4be02a968a57d1f3d5024a4b88e.png";